import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMoonLine = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M6.85678 1.49871C6.80449 1.49631 6.75277 1.501 6.70444 1.51433C3.88443 2.321 1.91147 4.93502 1.91147 7.87501C1.91147 11.5283 4.88459 14.4948 8.53126 14.4948V14.5013C11.4646 14.5013 14.0853 12.5285 14.8919 9.70185C14.9453 9.50852 14.8643 9.26211 14.7109 9.13545C14.5576 9.00878 14.2985 8.98092 14.1185 9.07425C12.1918 10.1009 9.76543 9.7355 8.21876 8.18883C6.66542 6.64215 6.30422 4.21443 7.32423 2.28777C7.4309 2.09444 7.40418 1.86199 7.27084 1.69532C7.17584 1.58032 7.01366 1.50589 6.85678 1.49871ZM6.01824 2.85548H6.02475C5.37808 4.94881 5.93157 7.30788 7.51824 8.89454C9.1049 10.4879 11.4653 11.0347 13.5586 10.388C12.6186 12.2614 10.6779 13.5013 8.53126 13.5013C5.43126 13.5013 2.91147 10.9815 2.91147 7.88152C2.91147 5.73487 4.15157 3.79548 6.01824 2.85548Z",
		fill: "currentColor"
	})
});
export default SvgMoonLine;
